import { createContext } from "react";

export const UserIdContext = createContext<string | undefined>(undefined);
